import { render, staticRenderFns } from "./AddEditOtherBenefits.vue?vue&type=template&id=61994f3f&scoped=true"
import script from "./AddEditOtherBenefits.vue?vue&type=script&lang=js"
export * from "./AddEditOtherBenefits.vue?vue&type=script&lang=js"
import style0 from "./AddEditOtherBenefits.vue?vue&type=style&index=0&id=61994f3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61994f3f",
  null
  
)

export default component.exports